import { StorageSerializers } from '@vueuse/core';

export type CustomerContacts = {
    email: string;
    phone: string;
};

const STORAGE_KEY = 'lead_contacts';
const TTL_MS = 30 * 24 * 60 * 60 * 1000;

type UseCustomerContactsCacheReturn = {
    getCached: () => CustomerContacts | null;
    setCached: (contacts: CustomerContacts) => void;
    clearCached: () => void;
};

export const useCustomerContactsCache = (): UseCustomerContactsCacheReturn => {
    const cachedContacts = useLocalStorage<{ data: CustomerContacts; ts: number } | null>(STORAGE_KEY, null, {
        serializer: StorageSerializers.object,
    });

    const getCached = (): CustomerContacts | null => {
        if (!cachedContacts.value) return null;

        if (Date.now() - cachedContacts.value.ts > TTL_MS) {
            cachedContacts.value = null;

            return null;
        }

        return cachedContacts.value.data;
    };

    const setCached = (contacts: CustomerContacts): void => {
        cachedContacts.value = { data: contacts, ts: Date.now() };
    };

    const clearCached = (): void => {
        cachedContacts.value = null;
    };

    return { getCached, setCached, clearCached };
};
